import { EnvironmentStore } from "./envTypes";

export function selectCurrentEnvironment({ environment }: EnvironmentStore) {
    return environment.current
}
